export const iconFontAwesomeHumanitarianToiletPortable = (
	<i className="fa-solid fa-toilet-portable"></i>
);
